const de = {
  deleteFailed: 'Das Angebot konnte nicht gelöscht werden',
  deleteSuccessful: 'Das Angebot wurde erfolgreich gelöscht',
  deleteConfirm: {
    title: 'Wirklich löschen?',
    message: 'Wollen Sie dieses Angebot wirklich unwiderruflich löschen?'
  },
  postedBy: 'Eingestellt von',
  postedOn: 'am {{date}}'
};

export default de;
export type ListingDetailTranslation = typeof de;
